import {actions} from '../actions';

export const initialState = {
  serviceHandle: null,
  previousServiceHandle: null,
  files: {},
  organization: null,
  services: [],
  activeTaxonomyNode: null,
  breadcrumbs: [],
  browseContext: false,
};

export default function contextReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FILES.ATTACH_FILES: {
      const {inputHandle, files} = action.payload;
      const inputFiles = state.files[inputHandle] || [];

      return {
        ...state,
        files: {
          ...state.files,
          [inputHandle]: [...inputFiles, ...files],
        },
      };
    }

    case actions.FILES.REMOVE_FILE: {
      const {inputHandle, file} = action.payload;
      const inputFiles = state.files[inputHandle] || [];

      return {
        ...state,
        files: {
          ...state.files,
          [inputHandle]: inputFiles.filter(
            attachedFile => attachedFile !== file
          ),
        },
      };
    }

    case actions.PROGRESS.RESET_SERVICE_SELECTION: {
      return {...state, files: {}};
    }

    case actions.SERVICES.SET_SERVICE_HANDLE: {
      const {serviceHandle, previousServiceHandle} = action.payload;
      return {
        ...state,
        previousServiceHandle: previousServiceHandle || state.serviceHandle,
        serviceHandle,
      };
    }

    case actions.SERVICE_SELECTOR.SET_ACTIVE_TAXONOMY_NODE: {
      const {activeTaxonomyNode} = action.payload;
      return {
        ...state,
        activeTaxonomyNode,
      };
    }

    case actions.SERVICE_SELECTOR.SET_BREADCRUMBS: {
      const {breadcrumbs} = action.payload;
      return {
        ...state,
        breadcrumbs,
      };
    }

    case actions.CONTEXT.SET_ORGANIZATION: {
      const {organization} = action.payload;
      return {...state, organization};
    }

    case actions.CONTEXT.REMOVE_ORGANIZATION: {
      return {...state, organization: null};
    }

    case actions.CONTEXT.SET_BROWSE: {
      return {...state, browseContext: true};
    }

    case actions.TAXONOMY.FETCH_FULFILLED: {
      return {
        ...state,
        services: action.payload,
        activeTaxonomyNode: action.payload,
      };
    }
  }

  return state;
}
